@import '@alfalab/core-components-vars/src/index.css';

.addons {
    padding-left: var(--gap-0);
}

.size-64,
.size-72 {
    & .addons {
        padding-left: var(--gap-0);
    }
}

.flagIconWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    margin-left: var(--gap-12);
}

.emptyCountryIcon {
    color: var(--color-light-neutral-700);
}
